module.exports = __webpack_public_path__ + "static/media/22861667_1638425206232664_2709859159218823704_o-thumb.14518876.jpg";